<template>
  <div class="button-container">
    <button
      v-if="shouldShowRateLimit"
      class="rate-limit-counter-button"
      :class="{ 'no-questions': questionsRemaining === 0 }"
      @click="onClick"
    >
      <rolling-number
        :value="questionsRemaining"
      />
    </button>
  </div>
</template>

<script>
import RateLimitMixin from '@/mixins/rate-limit';
import RollingNumber from '@/components/singletons/RollingNumber.vue';

export default {
  components: {
    RollingNumber,
  },
  mixins: [RateLimitMixin],
  methods: {
    onClick() {
      this.$store.dispatch('ui/toggleUpsellModal', {
        show: true,
        source: { type: 'Sidebar Counter Button', value: this.questionsRemaining },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.button-container {
  text-align: center;
}

.rate-limit-counter-button {
  position: relative;
  height: rem-calc(40);
  width: rem-calc(40);
  background: linear-gradient( -135deg, #a1bff9, #c4d1e9);
  color: white;
  font-weight: 600;
  font-size: rem-calc(16);
  border-radius: var(--radius-md);
  border: 1px solid #eef5fd;

  &.no-questions {
    background: linear-gradient( -135deg, #a2e1c1, #ccded5);

    &::before {
      background-color: #00aa5e;
    }
  }

  &::before {
    content: '';
    position: absolute;
    top: -7px;
    left: 4px;
    width: 100%;
    height: 100%;
    background-color: var(--primary-bg);
    transform: rotate(15deg);
    z-index: -1;
    border-radius: var(--radius-md);
  }
}
</style>
